import request from '@/utils/request'

// 管理员登录接口
export function login(param) {
  return request({
    url: '/user/login',
    method: 'post',
    data: param,
    isLoading: false,
  }).then(response => {
    console.log('API request successful:', response); // 打印API请求成功的响应
    return response;
  }).catch(error => {
    console.error('API request failed:', error); // 打印API请求失败的错误
    throw error;
  });
}

export const loginNum = (inStorageNo) => {
  return request({
    url: `/client/anno/loginNum?phone=${inStorageNo}`,
    method: 'get'
  })
}

// 管理员登出接口
export const logout = (username) => {
  return request({
    url: '/user/logout',
    method: 'post',
    data: {
      username
    }
  })
}

// 获取管理员信息
export const getInfo = (token) => {
  return request({
    url: '/client/anno/getRoles',
    method: 'get',
    params: { token }
  })
}

// 发送手机登录验证码
export const sendMobileVerifyCode = (data) => {
  return request({
    url: '/client/anno/sendMobileVerifyCode',
    method: 'post',
    data: data
  })
}
// 对比验证码的正确情况
export const compareVerifycode = (data) => {
  return request({
    url: '/client/anno/compareVerifycode',
    method: 'post',
    data: data
  })
}
// 注册	/client/customer/register
export const register = (data) => {
  return request({
    url: '/client/customer/register',
    method: 'post',
    data: data
  })
}
// 修改密码
export const resetpass = (data) => {
  return request({
    url: '/client/customer/resetpass',
    method: 'post',
    data: data
  })
}
export const getSignTypeList = () => {
  return request({
    url: `/sys/dict/listBusiness`,
    method: 'GET'
  })
}

export const zcDelectFile = (param) => {
  console.log(param)
  return request({
    url: `/client/cloud/file/deleteTransport`,
    method: 'POST',
    data: param
  })
}

// 新增后台管理员 POST /user/add
export const addUser = (data) => {
  return request({
    url: '/user/add',
    method: 'post',
    data,
  })
}

// 分页查询管理员列表 GET /user/list
export const getUserList = (params) => {
  return request({
    url: '/user/list',
    method: 'get',
    params,
  })
}

// 管理员信息详情 GET /user/detail/{id}
export const getUserDetail = (id) => {
  return request({
    url: `/user/detail/${id}`,
    method: 'get',
  })
}

// 修改管理员信息 PUT /user/modify/info
export const updateUser = (data) => {
  return request({
    url: '/user/modify/info',
    method: 'put',
    data,
  })
}

// 删除管理员 DELETE /user/remove/{id}
export const deleteUser = (id) => {
  return request({
    url: `/user/remove/${id}`,
    method: 'delete',
  })
}

// 启用/禁用管理员 PUT /user/enabled  body: { id, status }  1=启用 0=禁用
export const updateUserEnabled = (data) => {
  return request({
    url: '/user/enabled',
    method: 'put',
    data,
  })
}
